import { render, staticRenderFns } from "./MoreIcon.vue?vue&type=template&id=94c21c64&"
import script from "./MoreIcon.vue?vue&type=script&lang=ts&"
export * from "./MoreIcon.vue?vue&type=script&lang=ts&"
import style0 from "./MoreIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports